import styles from '../ConfigModal.module.css';

interface NavButtonProps {
  onClick: () => void;
  isActive: boolean;
  icon: React.JSX.Element;
  label: string;
  disabled?: boolean;
}

export function NavButton({
  onClick,
  isActive,
  icon,
  label,
  disabled,
}: NavButtonProps): React.JSX.Element {
  return (
    <button
      disabled={disabled}
      className={`${styles.navButton} ${isActive ? styles.active : ''} ${
        disabled ? styles.disabled : ''
      }`}
      onClick={onClick}
      type="button"
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
